import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _ from "lodash";
import React from "react";
import { change, Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import {
  Insurers,
  LifeAssured,
  Benificiary,
  Owner,
  Combos
} from "./objects/Policies";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const CustomField = props => (
  <TableCell className="cellPaddingSmall">
    <FormControl fullWidth>
      <Field {...props} />
    </FormControl>
  </TableCell>
);

const CustomField2 = props => (
  
    <FormControl fullWidth style={{ bottom: "10px" }}>
      <Field {...props} />
    </FormControl>
  
);



const required = value => (value ? undefined : "Required");

const requiredDropdown = value => {
  if (value === "validationError") {
    return "Required";
  } else if (value) {
    return undefined;
  } else {
    return "Required";
  }
};

const emptySelect = value => {
  if (!value || value === "validationError") {
    return true;
  }
  return false;
};

var Policy = value => {
  return (
    {
      description: "",
      estateInherit: 0,
      spouseInherit: 0,
      dependentInherit: 0,
      trustInherit: 0.00,
      otherInherit: 0.00,
      death: 0.00,
      disability: 0.00,
      criticalIllness: 0.00,
      dutyExcempt: false,
      party: "",
      LifeAssured: "",
      cashValue: 0.00
    }
  )
}

class Policies extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }

  componentDidUpdate()
  {
    var fieldsPolicies = 
    [
     {
       field: "policy",      
       fieldName: "death",  
       fieldVar: "death",   
       value: "0"
     },
     {
      field: "policy",      
      fieldName: "disability",  
      fieldVar: "disability",   
      value: "0"
    },
    {
      field: "policy",      
      fieldName: "criticalIllness",  
      fieldVar: "criticalIllness",   
      value: "0"
    },
    {
      field: "policy",      
      fieldName: "cashValue",  
      fieldVar: "cashValue",   
      value: "0"
    }
    

     
    ]

    this.props.initializeDynamicField("policiesInit", fieldsPolicies);
  }
  
  state = {
    policyValues: {}
  };

  addNew = () => {
    var policie = this.props.state.policy;
    var newPolicy = Policy();
    policie.push(newPolicy);
    //console.log("HELLO ", this.props.state.policy, " ", policie)
    this.props.changePolicy(policie);
  }

  remove = (n) => {
    var policie = this.props.state.policy;
    var newPolicy = [];
    var node = n.target;
    
    while(node.nodeName != "BUTTON" && node.parentNode != null)
    {
      node = node.parentNode
    }
    
    var i = node.name.replace("remove", "")
    console.log(i)
    //assets.splice(i, 1)
    //assets[i] = null;
    policie.map((e,k) =>
    {
      console.log(policie[i] == e)
      if(e != policie[i])
        newPolicy[k] = e
    })
    policie = newPolicy;
    this.props.changePolicy(newPolicy);
  }
 
  checkItem = (label, name, changeFunc) => {
    return (
      
              <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px", left:"30px"}}>
                <Field
                  component={FormCheckbox}
                  name={name}
                  onChange={(e, f, g, h) => {
                    changeFunc(f, h)

                  }}

                />
              </FormControl>
           
    );
  };
  

  changeDescription  = (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("description", "")
    policies[policy].description = value
    //this.props.changePolicy(policy);
  }
  changeEstate= (value, name) => 
  {
    //console.log(value + "---" + name)
    var policies = this.props.state.policy;
    var policy = name.replace("estate", "")
    policies[policy].estate = value
    //this.props.changePolicy(policy);
  }
  changeSpouse= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("spouse", "")
    policies[policy].spouse = value
    //this.props.changePolicy(policy);
  }
  changeDependent= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("dependent", "")
    policies[policy].dependent = value
    //this.props.changePolicy(policy);
  }
  changeTrust= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("trust", "")
    policies[policy].trust = value
    //this.props.changePolicy(policy);
  }
  changeOther= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("other", "")
    policies[policy].other = value
    //this.props.changePolicy(policy);
  }
  changeDeath= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("death", "")
    policies[policy].death = value
    //this.props.changePolicy(policy);
  }
  changeDisability= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("disability", "")
    policies[policy].disability = value
    //this.props.changePolicy(policy);
  }
  changeCriticalIllness= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("criticalIllness", "")
    policies[policy].criticalIllness = value
    //this.props.changePolicy(policy);
  }
  changeDutyExcempt= (value, name) => 
  {
    var policies = this.props.state.policy;
    var policy = name.replace("dutyExcempt", "")
    policies[policy].dutyExcempt = value
    //this.props.changePolicy(policy);
  }

  changeParty = (value, name) =>
  {
    var policies = this.props.state.policy;
    var polisie = name.replace("owner", "")
    policies[polisie].party = value;
  }

  changeAssured = (value, name) =>
  {
    var policies = this.props.state.policy;
    var polisie = name.replace("assured", "")
    policies[polisie].LifeAssured = value;
  }

  changeCashValue = (value, name) =>
  {
    var policies = this.props.state.policy;
    var polisie = name.replace("cashValue", "")
    policies[polisie].cashValue = value;
  }

  

 

  render() {
    let { checkValidation } = this.props;

    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname

    return (
      <div className="contentWithStepper" style={{ width: "120%", marginLeft: "-10%", flex: 1, height:"fit-content" }}>
        <Card >
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Policies"}
            />

            <Grid container spacing={24} className="customTableAutoGrid">
              <Table className="customTable1">
                <TableHead className="fixedHead">
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("20em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Description</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("20em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Owner</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("20em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Life Assured</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("12em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Death</Typography>

                    </TableCell>
                   <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("12em")}
                     
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Disability</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingSmall"
                      style={colwidth("12em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Critical Illness</Typography>

                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("20em")}
                      
                    >
                      <Typography style={{ fontSize: '16px', textAlign: "center" }}>Cash Value</Typography>

                    </TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                
      
                  {this.props.state.policy.map((e, i) => {
                    
                    return (
                      <TableRow key={i}>
                        

                        <TableCell>
                          <Button
                            name={"remove" + i}
                            key = {"remove" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>

                          <CustomField2
                          name={'description' + i}
                          component={FormInput}
                          checkValidation={this.props.checkValidation}
                          label={'Description'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeDescription(value, name)}
                        />
                          
                        </TableCell>
                        

                        <CustomField
                          name={"owner" + i}
                          component={FormDropdown}
                          checkValidation={this.props.checkValidation}
                          label={''}
                          isrequired={true}
                          //validate={[required]}
                          options=
                          {[
                            { displayValue: "Please select", value: " " },
                            { displayValue: "Client", value: "client" },
                            { displayValue: "Spouse", value: "spouse" },
                            { displayValue: "other", value: "other" }
                          ]}
                          onChange={(e, value, t, name) => this.changeParty(value, name)}
                        />


                          <CustomField
                          name={"assured" + i}
                          component={FormDropdown}
                          checkValidation={this.props.checkValidation}
                          label={''}
                          isrequired={true}
                          //validate={[required]}
                          options=
                          {[
                            { displayValue: "Please select", value: " " },
                            { displayValue: "Client", value: "client" },
                            { displayValue: "Spouse", value: "spouse" },
                            { displayValue: "other", value: "other" }
                          ]}
                          onChange={(e, value, t, name) => this.changeAssured(value, name)}
                        />
                        


      
     

                        

                       
                        <CustomField
                          name={'death' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeDeath(value, name)}
                        />
                        

                        <CustomField
                          name={'disability' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeDisability(value, name)}
                        />

                        <CustomField
                          name={'criticalIllness' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeCriticalIllness(value, name)}
                        />

                        <CustomField
                          name={'cashValue' + i}
                          prefix="R"
                          component={NumberInput}
                          checkValidation={this.props.checkValidation}
                          label={'R*'}
                          isrequired={true}
                          validate={[required]}
                          onChange={(e, value, t, name) => this.changeCashValue(value, name)}
                        />

                      


                      </TableRow>

                      

                    )

                  })}

                  <TableRow>
                    <Table style={{ width: "10em" }}>
                      <DescriptiveRow

                        description={"Add Policy"}
                        add={() =>
                          this.addNew()
                        }

                        extraCells={0}
                      />
                    </Table>
                  </TableRow>

                </TableBody>
              </Table>

            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Policies;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/Policies.jsx